// Analytics
import { sendEvent } from "@/lib/analytics"

// Template
import { PageTemplate } from "@/layouts/PageTemplate"

// Router
import { useNavigate } from "@/lib/router"
import { Routes } from "@/constants/routes"

// UI
import { ProjectSelector } from "@/components/ProjectSelector"
import { CardWrapper } from "@/components/Card"

// Specific UI
import { FinanceProjectsTable } from "./_components/FinanceProjectsTable"

// Translations
import { useTrans } from "@/i18n"

/**
 * FinanceDashboard
 * @returns
 */
export function FinanceDashboard() {
	const t = useTrans("finance")
	const navigate = useNavigate()

	return (
		<>
			<title>
				{t("common:web.title", {
					page: t("finance:finance_dashboard.title"),
				})}
			</title>
			<PageTemplate title={t("finance:finance_dashboard.title")}>
				<div className="w-full">
					<div className="mb-2 flex flex-col items-end">
						<ProjectSelector
							onChange={(id: string) => {
								sendEvent(
									"finance",
									"performance_project_filter",
									{
										label: id,
									},
								)
								void navigate(`${Routes.FinanceProjects}/${id}`)
							}}
						/>
					</div>

					<CardWrapper>
						<FinanceProjectsTable />
					</CardWrapper>
				</div>
			</PageTemplate>
		</>
	)
}
